<div [formGroup]="parentGroup" class="mt-3 mb-4 app-geocode-information">

  <div class="form-row d-flex mb-3 mt-3">
    <!-- Street Address -->
    <div class="wrap-mat-form-field mr-mobile-auto mb-mobile-4 f-1">
      <mat-form-field floatLabel="always">
        <mat-label>{{ 'REGISTER_FORM.STREET_ADDRESS' | translate }}</mat-label>
        <input
          [appBorderError]="isSubmitted"
          [formControlName]="fromWhichDialog === 'clinicSetup' ? 'address1' : 'street'"
          autocomplete="street-address"
          markWithAsterisk
          matInput
          name="address"
          trim
          maxlength="40"
          [readonly]="tribuneData"
          [ngClass]="{'read_only_bg' : tribuneData}"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="form-row d-flex mb-3 mt-3 flex-wrap">
    <!-- City -->
    <div class="wrap-mat-form-field mr-mobile-auto mb-mobile-4 mr-3 f-1 f-mobile-100">
      <mat-form-field floatLabel="always">
        <mat-label>{{ 'REGISTER_FORM.CITY' | translate }}</mat-label>
        <input
          [appBorderError]="isSubmitted"
          formControlName="city"
          matInput name="city"
          trim
          markWithAsterisk
          (keypress)="cityKeyPress($event)"
          maxlength="20"
          [readonly]="tribuneData"
          [ngClass]="{'read_only_bg' : tribuneData}"
        />
      </mat-form-field>
    </div>

    <!-- State -->
    <div class="wrap-mat-form-field mb-mobile-4 mr-3 w-130px">
      <mat-form-field class="f-1 mr-3 mr-mobile-auto" floatLabel="always">
        <mat-label>{{ 'REGISTER_FORM.STATE' | translate }}</mat-label>
        <input
          class="move"
          (change)="stateFilled($event)"
          name="state"
          autocomplete="address-level1"
        />
        <mat-select [appBorderError]="isSubmitted" formControlName="state" markWithAsterisk
        [disabled]="tribuneData" [ngClass]="{'read_only_bg' : tribuneData}">
          <mat-option *ngFor="let state of statesList" [value]="state">{{ state }} </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  
    <!-- ZIP Code -->
    <div class="wrap-mat-form-field mr-mobile-auto mb-mobile-4 w-130px">
      <mat-form-field floatLabel="always">
        <mat-label>{{ 'REGISTER_FORM.ZIP_CODE' | translate }}</mat-label>
        <input
          [formControlName]="fromWhichDialog === 'clinicSetup' ? 'zipcode' : 'zipCode'"
          [appBorderError]="isSubmitted"
          autocomplete="postal-code"
          markWithAsterisk
          matInput
          name="postal"
          maxlength="5"
          minlength="5"
          pattern="^(?=.*\d)(?=.*[1-9]).{5}$"
          trim
          (keypress)="numberOnly($event)"
          [readonly]="tribuneData"
          [ngClass]="{'read_only_bg' : tribuneData}"
          (change)="zipFilled($event)"
          #keyword
        />
      </mat-form-field>
    </div>
  </div>

  <div class="relative">
    <mat-error class="fs-12 mb-3 mt-2" *ngIf="isSubmitted && parentGroup?.errors && parentGroup.errors['notExist']">
      {{ 'REGISTER_FORM.ADDRESS_NOT_EXIST' | translate }}
    </mat-error>
  </div>
</div>
